import React from "react";
import ToolTip from 'components/Tooltip';

export interface OwnProps {
  active: boolean,
  hasEnoughFate: boolean,
  parent?: any | null,
}

export default function FateRefreshTooltip({ active, hasEnoughFate, parent }: OwnProps) {
  const data = {
    image: 'fate',
    secondaryDescription: hasEnoughFate
      ? 'Refresh your Actions with Fate...'
      : 'Not enough Fate! Purchase more...',
  };
  return <ToolTip active={active} data={data} parent={parent} />;
}

FateRefreshTooltip.displayName = 'FateRefreshTooltip';
